import { useFlag } from '@unleash/proxy-client-react';

import { getEnv } from './useEnv';

const allFlags = {
  // BETA:
  showNpsModule: true,
  // DELTA
  contactMenuBarImport: true,
  showBlockModalFreeTrialDemo: true,
  SkipButtonStepper: false,
  createContactsV2: false,
  distributeSegment: true,
  recentImportIsEnabled: true,
  discardedReasonsEnabled: true,
  showStatusCards: true,
  contactDownload: true,
  // Features no implemented
  showCampaigns: true,
  channelDateFilter: true,
  actionBarDropdown: true,
  actionBarGroupsFlowsIcon: true,
  actionBarSegmentsFlowsIcon: true,
  actionBarExportUserIcon: true,
  actionBarMergeTagIcon: true,
  actionBarEditTagCategoryIcon: true,
  activityLogCampaign: false,
  // Heavy operations that could be useful keep the control with the FF
  actionBarTagAddIcon: true,
  actionBarGroupAddIcon: true,
  actionBarFlowsIcon: true,
  // 4 DEVELOPERS
  showCrashButton: true,
  loginAuditStep: true,
  loginV2CheckCountry: false,
  MFA: true,
};

type AppFlagKeys = keyof typeof allFlags;

export const useFeatureFlag = (flag: AppFlagKeys) => {
  const env = getEnv();
  const isFlagEnabled = useFlag(flag);

  if (env === 'development' || env === 'storybook') {
    return allFlags[flag];
  }
  return isFlagEnabled;
};
